export default "__VITE_ASSET__96680853__"